if (window.HM) {
  window.HM.ready(function () {
    window &&
      window.HM &&
      window.HM.setFunctionButtons &&
      window.HM.setFunctionButtons({
        resize: {
          display: false,
        },
        refresh: {
          display: true,
        },
        share: {
          display: true,
          config: {
            global: {
              type: "card",
              title: window.currentArticle.title,
              description: window.currentArticle.summary_html,
              link: window.location.href,
              imgUrl: location.protocol + window.currentArticle.image.src,
              capture: 0,
            },
          },
        },
        success() {},
        timeOut() {},
        fail() {},
      });
  });
} else {
  console.log('not HM')
}
